var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchConsultar, fetchConsultarPaginada, fetchCadastrar, fetchAlterar, fetchDeletar, fetchArquivos, URL_API, } from '../../../api';
import { getTokenFromCookie } from '../../../services/mt_login';
export { STATUS_API } from '../../../api';
var ROTA_REEDUCANDOS = 'reeducandos';
export var getReeducandos = function (TextoBusca, Status, TipoRegime, DisponibilidadeContratacao, PaginationModel, VagaID) {
    if (VagaID === void 0) { VagaID = null; }
    return __awaiter(void 0, void 0, void 0, function () {
        var Query, URL;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    Query = '';
                    if (TextoBusca)
                        Query += "query=".concat(encodeURIComponent(TextoBusca), "&");
                    if (Status)
                        Query += "situacao=".concat(Status, "&");
                    if (TipoRegime)
                        Query += "tipo_regime=".concat(TipoRegime, "&");
                    if (DisponibilidadeContratacao !== null && DisponibilidadeContratacao !== undefined)
                        Query += "disponibilidade_contratacao=".concat(DisponibilidadeContratacao, "&");
                    if (VagaID)
                        Query += "vaga_id=".concat(VagaID, "&");
                    URL = "".concat(ROTA_REEDUCANDOS, "?").concat(Query);
                    return [4 /*yield*/, fetchConsultarPaginada(URL, PaginationModel)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
export var getCombosReeducandosDadosPessoais = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/combos-dados-pessoais"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getTiposRegimes = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/tipos-regimes"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getReeducando = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/").concat(ID))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var cadastrarReeducando = function (Dados) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS);
                return [4 /*yield*/, fetchCadastrar(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var alterarReeducando = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/").concat(ID);
                return [4 /*yield*/, fetchAlterar(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var excluirReeducando = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/").concat(ID);
                return [4 /*yield*/, fetchDeletar(URL)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var alterarStatusReeducando = function (ID, Status) { return __awaiter(void 0, void 0, void 0, function () {
    var Dados;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                Dados = { situacao: Status == 'Ativo' ? 'Inativo' : 'Ativo' };
                return [4 /*yield*/, alterarReeducando(Dados, ID)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
// ENDEREÇOS
export var getCombosEnderecos = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/enderecos/combos-enderecos"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getReeducandoEnderecos = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/").concat(ID, "/enderecos"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var cadastrarEndereco = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/").concat(ID, "/enderecos");
                return [4 /*yield*/, fetchCadastrar(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var alterarEndereco = function (Dados, ReeducandoID, ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/").concat(ReeducandoID, "/enderecos/").concat(ID);
                return [4 /*yield*/, fetchAlterar(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var excluirEndereco = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/enderecos/").concat(ID);
                return [4 /*yield*/, fetchDeletar(URL)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
//CONTATOS
export var getTiposContatos = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/contatos/tipos-contatos"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getReeducandoContatos = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/").concat(ID, "/contatos"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var cadastrarContato = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/").concat(ID, "/contatos");
                return [4 /*yield*/, fetchCadastrar(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var alterarContato = function (Dados, ReeducandoID, ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/").concat(ReeducandoID, "/contatos/").concat(ID);
                return [4 /*yield*/, fetchAlterar(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var excluirContato = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/contatos/").concat(ID);
                return [4 /*yield*/, fetchDeletar(URL)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
//DOCUMENTOS ANEXOS
export var getTiposDocumentos = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/documentos-anexos/tipos-documentos"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getReeducandoDocumentosAnexos = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/").concat(ID, "/documentos-anexos"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var cadastrarDocumentoAnexo = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/").concat(ID, "/documentos-anexos");
                return [4 /*yield*/, fetchArquivos(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var alterarDocumentoAnexo = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/documentos-anexos/").concat(ID);
                return [4 /*yield*/, fetchAlterar(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var excluirDocumentoAnexo = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/documentos-anexos/").concat(ID);
                return [4 /*yield*/, fetchDeletar(URL)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var gerarPDFReeducandos = function (TextoBusca, Status, TipoRegime, DisponibilidadeContratacao) { return __awaiter(void 0, void 0, void 0, function () {
    var Query, TOKEN, response, payload, pdfBlob, error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                Query = '';
                if (TextoBusca)
                    Query += "query=".concat(encodeURIComponent(TextoBusca), "&");
                if (Status)
                    Query += "situacao=".concat(Status, "&");
                if (TipoRegime)
                    Query += "tipo_regime=".concat(TipoRegime, "&");
                if (DisponibilidadeContratacao !== null && DisponibilidadeContratacao !== undefined) {
                    Query += "disponibilidade_contratacao=".concat(DisponibilidadeContratacao, "&");
                }
                TOKEN = getTokenFromCookie();
                _b.label = 1;
            case 1:
                _b.trys.push([1, 6, , 7]);
                return [4 /*yield*/, fetch("".concat(URL_API, "/").concat(ROTA_REEDUCANDOS, "/pdf/?").concat(Query), {
                        method: 'GET',
                        headers: {
                            Authorization: "Bearer ".concat(TOKEN),
                            'Content-Type': 'application/pdf',
                        },
                    })];
            case 2:
                response = _b.sent();
                if (!(response.status === 404)) return [3 /*break*/, 4];
                return [4 /*yield*/, response.json().catch(function () { return null; })];
            case 3:
                payload = _b.sent();
                alert((_a = payload === null || payload === void 0 ? void 0 : payload.message) !== null && _a !== void 0 ? _a : 'Não há dados para gerar o relatório.');
                return [2 /*return*/, null];
            case 4:
                if (!response.ok) {
                    throw new Error('Failed to fetch PDF');
                }
                return [4 /*yield*/, response.blob()];
            case 5:
                pdfBlob = _b.sent();
                return [2 /*return*/, window.URL.createObjectURL(pdfBlob)];
            case 6:
                error_1 = _b.sent();
                console.error('Erro ao gerar o PDF:', error_1);
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}); };
//FORMACOES
export var getReeducandoFormacoes = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/").concat(ID, "/formacoes"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getComboFormacoes = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/formacoes/combos"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var cadastrarFormacao = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/").concat(ID, "/formacoes");
                return [4 /*yield*/, fetchArquivos(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var alterarFormacao = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/formacoes/").concat(ID);
                return [4 /*yield*/, fetchAlterar(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var excluirFormacao = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/formacoes/").concat(ID);
                return [4 /*yield*/, fetchDeletar(URL)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
//EXPERIENCIAS PROFISSIONAIS
export var getReeducandoEProfissionais = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/").concat(ID, "/experiencias-profissionais"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getComboEProfissionais = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchConsultar("".concat(ROTA_REEDUCANDOS, "/experiencias-profissionais/combos"))];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var cadastrarEProfissional = function (Dados, ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/").concat(ID, "/experiencias-profissionais");
                return [4 /*yield*/, fetchCadastrar(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var alterarEProfissional = function (Dados, ReeducandoID, ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/").concat(ReeducandoID, "/experiencias-profissionais/").concat(ID);
                return [4 /*yield*/, fetchAlterar(URL, Dados)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var excluirEProfissional = function (ID) { return __awaiter(void 0, void 0, void 0, function () {
    var URL;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                URL = "".concat(ROTA_REEDUCANDOS, "/experiencias-profissionais/").concat(ID);
                return [4 /*yield*/, fetchDeletar(URL)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
